var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-top"},[_c('div',{staticClass:"tw-space-x-1"},[_c('span',[_vm._v(_vm._s(_vm.attachmentDate))]),(_vm.in24HourClock)?_c('span',[_vm._v(" "+_vm._s(_vm.date.format('HH:mm'))+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.date.format('LT'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }